import { HORECA } from '@/constants/testIds';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const FAQS = [
  { q: 'Minimum sipariş miktarı nedir?', a: 'İşletme türü ve ürün grubuna göre değişir. Küçük butik cafeler için mini paketler, oteller için palet bazlı çözümler sunuyoruz. Formu doldurmanız yeterli; ekibimiz size özel değerlendirme yapar.' },
  { q: 'Private label / özel etiket üretimi yapıyor musunuz?', a: 'Evet. Kendi markanıza özel tasarım etiketler, farklı gramajlar ve butik kavanoz seçenekleriyle üretim yapıyoruz. İhtiyacınızı formda belirtmeniz yeterli; talebinize göre değerlendirip size özel bir çözüm sunuyoruz.' },
  { q: 'Sertifikalarınız neler?', a: 'ISO 9001:2015 Kalite Yönetim Sistemi ve Organik Tarım Müteşebbis Sertifikası (ORSER denetimli) başta olmak üzere belgelerimizi "Belgeler & Güvence" bölümünden görüntüleyebilirsiniz. Talep halinde numune ile birlikte güncel sertifika kopyalarını paylaşıyoruz.' },
  { q: 'Teslimat süreleri ve lojistik nasıl işliyor?', a: 'Standart sevkiyat 2-5 iş günü içinde tüm Türkiye. Anlaşmalı işletmelere haftalık veya aylık düzenli sevkiyat planı çıkarıyoruz.' },
  { q: 'Ödeme koşulları nelerdir?', a: 'İlk sipariş peşin ödeme ile başlar. Düzenli müşterilerimize sipariş hacmine bağlı olarak vadeli çalışma imkânı sunulmaktadır.' },
  { q: 'Numune talep edebilir miyim?', a: 'Kurumsal talepler için ürün numunesi gönderiyoruz. Formda ilgilendiğiniz kategorileri seçmeniz süreci hızlandırır.' },
];

export default function FAQ() {
  return (
    <section
      id="sss"
      data-testid={HORECA.faqSection}
      className="relative paper-cream text-[#1F1F1F] py-24 md:py-32 overflow-hidden"
    >
      <div className="grain" />
      <div className="max-w-4xl mx-auto px-6 md:px-10 relative">
        <span className="eyebrow text-[#B08834] block mb-4">Sıkça Sorulanlar</span>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-14 font-light">
          Merak edilenler,
          <span className="italic text-[#B03A2E]"> netlikle</span>.
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="border-b border-[#1F1F1F]/15"
            >
              <AccordionTrigger className="text-left font-display text-xl md:text-2xl text-[#1F1F1F] py-6 hover:no-underline hover:text-[#B03A2E] transition-colors">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5A5145] text-base md:text-lg leading-relaxed pb-6 font-body font-light">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
